import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export const UploadButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'component'
})<{ component?: string }>(({ theme }) => ({
  color: theme.palette.text.secondary,
  borderColor: theme.palette.text.secondary,
  '&:hover': {
    borderColor: theme.palette.text.secondary
  }
})); 